module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Ice-cream2-006083b6e9edaa89b0d947fa75b468ad.svg";